import styled from 'styled-components';

export const Label = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
`;

export const SelectInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = styled.input<{ isMobile: boolean }>`
  color: #333f48;
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: ${(props) => (props.isMobile ? '3px' : '0')};
  padding: ${(props) => (props.isMobile ? '11px 16px' : '16px')};
  position: relative;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  border: none;
  ${(props) =>
    props.isMobile
      ? 'border: 1px solid #D2D5DA'
      : 'border-right: 1px solid #D2D5DA'};
  &:focus {
    outline: 2px solid #333f48;
    border-color: transparent;
    z-index: 1;
  }
  ::placeholder {
    color: #697684;
    opacity: 1;
  }
`;

interface DropdownProps {
  isShow: boolean;
  isMobile: boolean;
}

export const Dropdown = styled.div<DropdownProps>`
  position: absolute;
  width: 100%;
  z-index: 9999;
  margin-top: 6px;
  border-radius: 2px;
  opacity: ${(props) => `${props.isShow ? '1' : '0'}`};
  max-height: ${(props) =>
    `${props.isShow ? (props.isMobile ? '500px' : '230px') : '0'}`};
  transition:
    max-height ease-in 100ms,
    opacity ease-in 100ms;
  background-color: #ffffff;
  overflow-y: scroll;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  ::-webkit-scrollbar {
    width: 0;
  }
`;

export const DropdownItemSelector = styled.a`
  width: 100%;
  padding: 8px 16px;
  font-size: 16px;
  color: #333f48;
  display: block;

  &:hover {
    background-color: #f3f4f6;
    color: #333f48;
  }

  background-color: #ffffff;
`;

export const Icon = styled.div`
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  z-index: 1;
  padding-right: 18px;
`;
